import React, { useEffect } from 'react'
import CustomToast from '../../site-management/components/ToastComponent'
import { CircularProgress } from '@mui/material'
import Modal from '../../../components/Modal'
import AuthError from '../../../components/ErrorComponents/AuthError'
import { useSelector } from 'react-redux'
import { type RootState } from '../../../store'

const SaveDefaultViewWrapper = (): JSX.Element => {
  const saveDefaultAssetStatus = useSelector((state: RootState) => state.SaveDefaultViewData)
  const [showSuccessAssetPopUp, setshowSuccessAssetPopUp] = React.useState(false)
  const SaveDefaultViewData = useSelector((state: RootState) => state.SaveDefaultViewData)

  const handleOkandClose = (): void => {
    if (saveDefaultAssetStatus.httpStatus === 201) {
      setshowSuccessAssetPopUp(false)
    } else {
      setshowSuccessAssetPopUp(false)
    }
  }

  useEffect(() => {
    if (SaveDefaultViewData.httpStatus === 201) {
      CustomToast({
        type: 'success',
        heading: 'Save Default View Success',
        message: 'Selected view saved successfully'
      })
    } else if (!SaveDefaultViewData.isLoading && SaveDefaultViewData.loadingError !== undefined) {
      CustomToast({
        type: 'error',
        heading: 'Save Default View Error',
        message: 'Thermal Asset not found'
      })
    }
  }, [SaveDefaultViewData])

  const handleSaveDeafultGraphWithFailure = (): JSX.Element => {
    if (saveDefaultAssetStatus.httpStatus === 201) {
      return (
            <Modal
              buttonTypeNegative='hollow'
              title={'Asset Default Status'}
              LabelPositive={'Ok'}
              onClickPositive={() => { handleOkandClose() }}
              onClose={() => { handleOkandClose() }}
            >
              <p style={{ paddingTop: '1.2em', fontSize: '18px' }}>
                {saveDefaultAssetStatus.httpStatus === 201 ? 'Sucessfullly Updated' : saveDefaultAssetStatus.loadingError}
              </p>
            </Modal>
      )
    } else if (saveDefaultAssetStatus.isLoading) {
      return (
            <Modal title={'Loading...'}>
              <div className='CircularprogressAmi'>
                <CircularProgress />
              </div>
            </Modal>
      )
    } else if (saveDefaultAssetStatus.httpStatus === 400) {
      return (
            <Modal buttonTypeNegative='hollow'
              title={'Asset Default Status'}
              LabelPositive={'Ok'}
              onClickPositive={() => { handleOkandClose() }}
              onClose={() => { handleOkandClose() }}
            >
              <p style={{ paddingTop: '1.2em' }}>
                {saveDefaultAssetStatus.loadingError}
              </p>
            </Modal>
      )
    } else if (saveDefaultAssetStatus.httpStatus === 401) {
      return (
            <div className='authError'><AuthError errorMessage='Unauthorized' /></div>
      )
    } else if (saveDefaultAssetStatus.httpStatus === 403) {
      return (
            <div className='authError'><AuthError errorMessage='accessForbidden' /></div>
      )
    } else {
      return (
            <Modal
              buttonTypeNegative='hollow'
              title={'Asset Default Status'}
              LabelPositive={'Ok'}
              onClickPositive={() => {
                setshowSuccessAssetPopUp(false)
              }}
              onClose={() => {
                setshowSuccessAssetPopUp(false)
              }}
            >
              <p style={{ paddingTop: '1.2em' }}>
                {saveDefaultAssetStatus.loadingError}
              </p>
            </Modal>
      )
    }
  }

  return (
    <>
        {showSuccessAssetPopUp && handleSaveDeafultGraphWithFailure()}
    </>
  )
}
export const MemoSaveDefaultViewWrapper = React.memo(SaveDefaultViewWrapper)
